"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.for-each.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.number.to-fixed.js");
var _utils = require("../utils");
var _touch = require("../mixins/touch");
var _field = require("../mixins/field");
var _event = require("../utils/event");
var _icon = _interopRequireDefault(require("../icon"));
var _use = (0, _utils.use)('rate'),
  sfc = _use[0],
  bem = _use[1];
var _default = sfc({
  mixins: [_touch.TouchMixin, _field.FieldMixin],
  props: {
    size: Number,
    gutter: Number,
    readonly: Boolean,
    disabled: Boolean,
    disableTouch: {
      type: Boolean,
      default: false
    },
    accuracy: {
      type: String,
      default: 'int',
      validator: function validator(val) {
        return ['int', 'half', 'origin'].includes(val);
      }
    },
    value: {
      type: Number,
      default: 0
    },
    count: {
      type: Number,
      default: 5
    },
    icon: {
      type: String,
      default: 'star'
    },
    voidIcon: {
      type: String,
      default: 'star-o'
    },
    color: String,
    voidColor: String,
    disabledColor: String
  },
  computed: {
    list: function list() {
      var list = [];
      for (var i = 1; i <= this.count; i++) {
        list.push(this.getRateValue(this.value, i));
      }
      return list;
    }
  },
  methods: {
    select: function select(value) {
      if (!this.disabled && !this.readonly && value !== this.value) {
        this.$emit('input', value);
        this.$emit('change', value);
      }
    },
    onTouchStart: function onTouchStart(event) {
      if (this.readonly || this.disabled || this.disableTouch) {
        return;
      }
      this.touchStart(event);
      var rects = this.$refs.items.map(function (item) {
        return item.getBoundingClientRect();
      });
      var ranges = [];
      rects.forEach(function (rect, index) {
        ranges.push({
          index: index,
          left: rect.left,
          width: rect.width
        });
      });
      this.ranges = ranges;
    },
    onTouchMove: function onTouchMove(event) {
      if (this.readonly || this.disabled || this.disableTouch) {
        return;
      }
      this.touchMove(event);
      if (this.direction === 'horizontal') {
        (0, _event.preventDefault)(event);
        var clientX = event.touches[0].clientX;
        this.select(this.getScoreByPosition(clientX));
      }
    },
    getScoreByPosition: function getScoreByPosition(x) {
      for (var i = this.ranges.length - 1; i >= 0; i--) {
        if (x > this.ranges[i].left) {
          var score = this.ranges[i].index;
          var offset = x - this.ranges[i].left;
          if (offset >= this.ranges[i].width || this.accuracy === 'int') {
            return score + 1;
          } else {
            var half = this.getRateValue(offset / this.ranges[i].width, 1);
            return +(score + half).toFixed(2);
          }
        }
      }
      return 0;
    },
    getRateValue: function getRateValue(value, index) {
      if (index - value <= 0) {
        return 1;
      }
      if (index - value < 1) {
        if (this.accuracy === 'half') {
          return index - value <= 0.5 ? 0.5 : 0;
        }
        if (this.accuracy === 'origin') {
          return +(value % 1).toFixed(2); // 实际精度为0.01
        }
      }

      return 0;
    },
    renderStar: function renderStar(value, index) {
      var _this = this;
      var h = this.$createElement;
      var icon = this.icon,
        accuracy = this.accuracy,
        color = this.color,
        count = this.count,
        voidIcon = this.voidIcon,
        disabled = this.disabled,
        voidColor = this.voidColor,
        disabledColor = this.disabledColor;
      var showHalfIcon = accuracy !== 'int' && value > 0 && value < 1;
      var style;
      if (this.gutter && index < count - 1) {
        style = {
          paddingRight: this.gutter + "px"
        };
      }
      return h("div", {
        "ref": "items",
        "refInFor": true,
        "key": index,
        "style": style,
        "class": bem('item')
      }, [h(_icon.default, {
        "attrs": {
          "size": this.size ? this.size + "px" : undefined,
          "name": value === 1 ? icon : voidIcon,
          "color": disabled ? disabledColor : value === 1 ? color : voidColor
        },
        "class": bem('icon', {
          'full': value === 1,
          'void': value !== 1,
          'disabled': disabled
        }),
        "on": {
          "click": function click() {
            return _this.select(index + 1);
          }
        }
      }), showHalfIcon && h(_icon.default, {
        "attrs": {
          "size": this.size ? this.size + "px" : undefined,
          "name": icon,
          "color": disabled ? disabledColor : color
        },
        "class": bem('icon', disabled ? 'half-disabled' : 'half'),
        "style": {
          width: value + "em"
        }
      })]);
    }
  },
  render: function render() {
    var _this2 = this;
    var h = arguments[0];
    return h("div", {
      "class": bem(),
      "on": {
        "touchstart": this.onTouchStart,
        "touchmove": this.onTouchMove
      }
    }, [this.list.map(function (value, index) {
      return _this2.renderStar(value, index);
    })]);
  }
});
exports.default = _default;